import { h } from "preact";

import { useRef } from "preact/hooks";

import classname from "../../../../foundation/utils/classname";
import IconHintClose from "../../../v2/Icons/IconHintClose";
import OnlyIconButton from "../../OnlyIconButton";
import FilterInput from "../FilterInput";
import { InputProps } from "..";

import styles from "./SearchInput.module.css";

type InheritedInputProps = Omit<InputProps, "icon" | "inputRef">;

interface Props extends InheritedInputProps {
    onInput?: (ev: Event) => void;
    onClearSearch: () => void;
    onKeyDown?: (ev: KeyboardEvent) => void;
}

const DEFAULT_SEARCH_DELAY = 300; // ms

function SearchInput({
    class: cssClass,
    value: valueProp,
    onInput,
    onClearSearch,
    onKeyDown,
    ...inputProps
}: Props) {
    const inputRef = useRef<HTMLInputElement>(null);

    function handleClearSearch() {
        onClearSearch();
        inputRef.current?.focus();
    }

    function getCloseIcon() {
        return <IconHintClose/>;
    }

    return (
        <div class={classname(cssClass, styles.searchInputWrapper)}>
            <FilterInput
                {...inputProps}
                inputRef={inputRef}
                class={styles.searchInput}
                inputClass={styles.searchInputElement}
                filterDelay={DEFAULT_SEARCH_DELAY}
                shouldCaptureSearchShortcut={false}
                shouldClearOnEscape
                hideIcon
                autoFocus
                value={valueProp}
                onInput={onInput}
                onKeyDown={onKeyDown}/>
            {
                valueProp && (
                    <OnlyIconButton
                        class={styles.clearSearchFieldButton}
                        icon={getCloseIcon}
                        onClick={handleClearSearch}/>
                )
            }
        </div>
    );
}

export default SearchInput;
